const Button = {
  baseStyle: {
    borderRadius: "8px",
  },
  variants: {
    primary: {
      _hover: {
        border: "none",
        bg: "brand.primary",
        boxShadow: "none",
      },
      _focus: {
        border: "none",
        boxShadow: "none",
        outline: "none",
      },
      _active: {
        border: "none",
        boxShadow: "none",
        outline: "none",
      },
      _disabled: {
        bg: "brand.textInactive",
        pointerEvents: "none",
      },
    },
    solid: {
      _dark: {
        bg: "primary.500",
        color: "white",
      },
      _hover: {
        _dark: {
          bg: "primary.400",
        },
      },
    },
    outline: {
      _hover: {},
      _dark: {
        borderColor: "primary.400",
        color: "white",
      },
    },
  },
  defaultProps: {
    variant: "primary",
  },
};

export default Button;
